import { render, staticRenderFns } from "./ToggleCard.vue?vue&type=template&id=48ff101d&scoped=true"
import script from "./ToggleCard.vue?vue&type=script&lang=js"
export * from "./ToggleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff101d",
  null
  
)

export default component.exports